import { Typography } from '@pesto/ui';
import { Card } from '@pesto/ui/components/Card';
import { DataList } from '@pesto/ui/components/DataList';
import { JsonViewer } from '@pesto/ui/components/JsonViewer';
import { LoadingSpinner } from '@pesto/ui/components/LoadingSpinner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@pesto/ui/components/Tabs';

import type { StatementListItem } from '../types/Statements.types';

import { AccountActivitySection } from './AccountActivitySection';
import { StatementDetailsCard } from './StatementDetailsCard';

interface StatementDetailsContentProps {
  statement?: StatementListItem | null;
  loading?: boolean;
  getLoanHref?: (loanId: string) => string;
}

export const StatementDetailsContent = ({ statement, loading, getLoanHref }: StatementDetailsContentProps) => {
  if (loading) {
    return <LoadingSpinner />;
  }

  if (!statement) {
    return <Typography variant="headerLarge">No statement found</Typography>;
  }

  const statementWithoutPdfDataSnapshot = {
    ...statement,
    pdfDataSnapshot: undefined,
  };

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="headerLarge">Statement Details</Typography>
      <Tabs defaultValue="normal">
        <TabsList>
          <TabsTrigger value="normal">Normal</TabsTrigger>
          <TabsTrigger value="raw">Raw</TabsTrigger>
        </TabsList>
        <TabsContent value="normal">
          <div className="grid grid-cols-[repeat(auto-fit,minmax(400px,1fr))] gap-4">
            <AccountActivitySection pdfDataSnapshot={statement.pdfDataSnapshot} />
            <StatementDetailsCard statement={statement} getLoanHref={getLoanHref} />
          </div>
        </TabsContent>
        <TabsContent value="raw" className="grid grid-cols-[repeat(auto-fit,minmax(400px,1fr))] gap-4">
          <Card className="bg-card flex flex-col gap-6 p-6">
            <div className="flex flex-col flex-wrap gap-4 overflow-x-auto">
              <DataList root={statementWithoutPdfDataSnapshot} />
            </div>
          </Card>
          {statement.pdfDataSnapshot != null && (
            <Card className="bg-card flex flex-col gap-6 p-6">
              <Typography variant="headerLarge">PDF Data Snapshot</Typography>
              <div className="flex flex-col flex-wrap gap-4 overflow-x-auto">
                <JsonViewer data={statement.pdfDataSnapshot} collapsed={1} />
              </div>
            </Card>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};
